'use client'

import * as React from 'react'

// Light theme is forced site-wide — no theme switching needed.
// next-themes removed to eliminate the script tag warning in React 19 / Next.js 16.
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
